module.exports = __webpack_public_path__ + "static/media/Wormadam_gaussian2.3d444c57.png";